import { access } from '@/utils/featureset.js'
import lodash from 'lodash'

export function adjustEditability (feature, fields) {
  if (!access(feature, 'cud')) {
    // если нет разрешения 'CreateUpdateDelete' на фичу feature, то ставим полям editable = false
    lodash.forEach(fields, (field) => {
      if (lodash.hasIn(field, 'spec.editable')) {
        field.spec.editable = false
      }
    })
    fields.find((f) => {
      return f.spec.name === 'status_code'
    }).possible_values = null
  }
  return fields
}

export function adjustActions (feature, actions) {
  if (!access(feature, 'cud')) {
    actions = { ...actions, create: false, update: false, delete: false }
  }
  return actions
}
